import React, { Component, PropTypes } from 'react';



class Flow extends Component {
  constructor(props) {
    super(props);
  }

  render() {
  	if (! this.props.cur) return null;

  	let curWidth = this.props.cur ? this.props.cur / this.props.max * this.props.radius : this.props.radius;
  	let maxWidth = this.props.cur ? this.props.radius : null;

    var dots = [];
    let variantX,variantY,posFrom,posTo;
    let maxDots = Math.floor(this.props.cur / this.props.max * 150);

    for (var i = 0; i < maxDots; i++) {
        variantX = Math.random();
        variantY = Math.random();
        posFrom = (this.props.fromX-25+(variantX*50))+' '+(this.props.fromY-25+(variantY*45));
        posTo = (this.props.toX-10+(variantX*20))+' '+(this.props.toY-10+(variantY*20));
        dots.push(
          <circle key={'circle'+i} r={2} fill="rgb(100,100,100)">
            <animateTransform attributeName="transform"
              type="translate"
              from={posFrom} 
              to={posTo} 
              dur={1.8+(variantX*1.2)}
              begin={0+(variantY*4)}
              repeatCount="indefinite"/>
          </circle>
        );
    }

	return (
		<g>
      {dots}
		</g>
		);
	}
}



Flow.propTypes = {
  title: PropTypes.string.isRequired,
  fromX: PropTypes.number.isRequired,
  fromY: PropTypes.number.isRequired,
  toX: PropTypes.number.isRequired,
  toY: PropTypes.number.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
  cur: PropTypes.number,
};

Flow.defaultProps = {
  title: 'Title',
  fromX: 100,
  fromY: 100,
  toX: 200,
  toY: 200,
  max: null,
  min: null,
  cur: null,
  colors: {
  	primary: 'green',
  	secondary: 'red'
  },
};

export default Flow;


// WEBPACK FOOTER //
// ./src/views/Bubbles/Flow.jsx